import gql from 'graphql-tag';

/**
 * The EPOS kiosk's own theme config, replacing the online-ordering theme
 * EPOS borrowed before it had settings of its own. Non-color fields
 * (limitedToServiceType, onlyPrintReceipt, exitMessage,
 * orderNumberPrintMessage) are fetched here too since they live on the same
 * `EPOSConfig` node, but only the colors are wired into `useEposTheme` for
 * now - see ThemeProvider/index.tsx.
 *
 * Each color below is described for backoffice ("Settings & design" for the
 * kiosk) with the CSS variable it becomes and where that variable is used -
 * see the --epos* table in styles/index.css.
 */
export const EPOS_CLOUD_CONFIG_QUERY = gql`
  query EposCloudConfig {
    operativeViewer {
      eposCloudConfig {
        id
        # "Primary color" - background of navigation surfaces: the category
        # rail and the loading screens. Becomes --eposPrimary.
        main
        # "Accent color" - text and icon color on top of the primary color,
        # e.g. the category rail's labels. Becomes --eposAccent.
        contrastingColor
        # "Secondary color" - background of the action buttons (checkout,
        # add to cart, service-type cards). Becomes --eposButton.
        secondary
        # "Price button" - background of the price badge shown on menu
        # items. Becomes --eposPrice.
        priceColor
        # "Category background" - background of a category tile that has no
        # photo of its own. Becomes --eposCategoryBackground.
        menuBackgroundColor
        # "Category text" - the category name on those photo-less tiles.
        # Becomes --eposCategoryText.
        menuTextColor
        limitedToServiceType
        onlyPrintReceipt
        exitMessage
        orderNumberPrintMessage
        backgroundMediaSrcUrl
        qrCodeLink
        iconImageSrcUrl
        oneModificationGroupPerPage
      }
    }
  }
`;
